import userHttpRequestInstance from '../http_requests/user/user_http_requests';
import userConverter from '../converters/user/user_converter';
import UserEntity from '../entities/user/user_entity'

const finderUser = (
   identifier: {
      email?: string,
      phone_number?: string,
      username?: string
   },
   observer: {
      receiveUserInfo: Function,
      receiveUserError: Function
   }
) => {
   userHttpRequestInstance.findUser(identifier, {
      success:(userInfo: UserEntity) => {
         observer.receiveUserInfo(userConverter(userInfo));
      },
      failure: (error: any) => {
         observer.receiveUserError(error);
      }
   });
};

export default finderUser;
